var map = {
	"./hellohr/circle-2.png": "2CsU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mqH2";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/circle\-2\.png$
// module id = mqH2
// module chunks = 0